import { render, staticRenderFns } from "./LoadingRedirectPage.vue?vue&type=template&id=2858cf40&scoped=true"
import script from "./LoadingRedirectPage.vue?vue&type=script&lang=ts"
export * from "./LoadingRedirectPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2858cf40",
  null
  
)

export default component.exports